import { useLocation } from "react-router";

import { useSelector } from "common/utilities/react-redux";
import { useTranslate } from "common/utilities/useTranslate";
import { getListedCollections } from "domains/collection/selectors";
import { buildCreate, buildDiscover, buildHome, buildMonitor, buildMore } from "domains/nav/helpers/buildMenuItems";
import { extractSubnavTerms } from "domains/nav/helpers/extractSubnavTerms";
import { getActiveItemId } from "domains/nav/helpers/getActiveItemId";
import type { SubnavMenuItemInput } from "domains/nav/types/hostCommand";
import { useTheme } from "domains/theme/useTheme";
import { showWhatsNewIcon } from "domains/whatsNew/selectors";
import { getCanDisplayBookmarks } from "entities/permissions/selectors";

export const useSubnavMenuItems = () => {
  const { pathname } = useLocation();
  const canDisplayBookmarks = useSelector(getCanDisplayBookmarks);
  const customTopicCount = useSelector((state) => state.topic.customTopicsCount);
  const listed = useSelector(getListedCollections);
  const showWhatsNew = useSelector(showWhatsNewIcon);
  const theme = useTheme();
  const translate = useTranslate();

  const subnavTerms = extractSubnavTerms(translate);

  const buildMenuItems = (isAuthenticated: boolean): SubnavMenuItemInput[] => {
    const items: SubnavMenuItemInput[] = [
      buildHome(subnavTerms.home),
      buildDiscover(subnavTerms.discover, listed, customTopicCount),
      buildMonitor(subnavTerms.monitor),
      buildCreate(subnavTerms.create),
      buildMore(subnavTerms.more, isAuthenticated, showWhatsNew, theme, canDisplayBookmarks),
    ];

    const activeItemId = getActiveItemId(pathname);
    const activeItem = activeItemId === undefined ? undefined : items.find(({ id }) => id === activeItemId);
    if (activeItem !== undefined && activeItem.divider === undefined) activeItem.active = true;
    return items;
  };

  return { public: buildMenuItems(false), user: buildMenuItems(true) };
};
